import { getConnections } from '@/redux/requests/connectionsRequests.js';
import testCompanyCredential from '@/redux/requests/credentials/testCompanyCredential.js';

/** Asks the app whether a saved connection still works, then reloads the list with the new status. */
const checkConnection = ({ connection, appVersion }) => {
  return async () => {
    const testRes = await testCompanyCredential({ credentialId: connection.credentialId, appId: connection.appId, appVersion });
    await getConnections();
    return testRes;
  };
};

export default checkConnection;
